<template>
  <div class="reportGroups">
    <report-table v-if="reports.peas" :peaData="reports.peas" />
    <div  v-if="reports.groups">
    <div class="group" v-for="group in reports.groups" v-bind:key="group.id">
      <h3 :class="{closed: !group.panelOpen, urgent: checkUrgent(group.groupIdentifier)}">{{ buildTitle(group.groupIdentifier) }}<el-badge :value="group.peaCount"/></h3>
      <span class="toggle" @click="group.panelOpen = !group.panelOpen" :class="{closed: !group.panelOpen}"></span>
      <transition name="panel">
        <div class="pea-panel" v-if="group.panelOpen" :class="{urgent: checkUrgent(group.groupIdentifier)}">
          <div class="groupInfo">
            <strong>Estimated Cost:</strong> ${{ formatMoney(group.totalNetExpenditure) }}
            <strong>Cost To Date:</strong> ${{ formatMoney(group.totalCostToDate) }}
          </div>

          <report-table v-if="group.peas" :peaData="group.peas" />

          <!-- sub groups -->
          <report-groups v-if="group.groups" :reportsData="group" :reportTypes="reportTypes" :componentIndex="componentNewIndex + 1" />

        </div>
      </transition>
    </div>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
import router from '@/router'
export default {
  name: 'report-groups',
  props: {
    reportsData: {},
    reportTypes: null,
    componentIndex: 0
  },
  data () {
    return {
      reports: this.reportsData,
      componentNewIndex: this.componentIndex
    }
  },
  methods: {
    formatMoney: function (money) {
      return helperMethods.formatMoney(parseFloat(money))
    },
    capitalize: function (input) {
      return input.charAt(0).toUpperCase() + input.slice(1)
    },
    formatDate: function (date) {
      return helperMethods.formatDate(helperMethods.convertDatetoISO(date))
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    },
    checkUrgent: function (groupIdentifier) {
      if (typeof this.reportTypes === 'object') {
        return (this.reportTypes[this.componentNewIndex] === 'urgency' && groupIdentifier === 'True')
      } else {
        return (this.reportTypes === 'urgency' && groupIdentifier === 'True')
      }
    },
    buildTitle: function (groupName) {
      if (typeof this.reportTypes === 'object') {
        var reportType = this.reportTypes[this.componentNewIndex]
        if (reportType === 'urgency') {
          return groupName === 'True' ? 'Urgent' : 'Not Urgent'
        }
        return this.capitalize(reportType) + ': ' + groupName
      } else {
        if (this.reportTypes === 'urgency') {
          if (groupName === 'True') {
            return 'Urgent'
          } else {
            return 'Not Urgent'
          }
        }
        return this.capitalize(groupName)
      }
    }
  }
}
</script>

<style>

h3.urgent {
  background-color: #f56c6c !important;
}

h3.urgent .el-badge .el-badge__content {
  background-color: white;
  color: #f56c6c;
}

.pea-panel.urgent {
  border-color: #f56c6c !important;
}

</style>
